import './home.css'
import MainHeader from '../../components/MainHeader'
// import Header from '../../components/Header'

import Classes from '../../components/Classes'
import Values from '../../components/Values'
import YogaCalendar from '../../components/YogaCalendar'
import FAQs from '../../components/FAQs'
// import Testimonials from '../../components/Testimonials'


const Home = () => {
  return (
    <>
    <MainHeader/>
    <Classes/>
    <YogaCalendar/>
    <Values/>
    <FAQs/>
    {/* <Testimonials /> */}
    </>
  )
}

export default Home